@if (isVisible()) {
<footer>
    <div [innerHTML]="dynamicFooter"></div>
</footer>
}